// https://cmsdev.cruisecode.com/BookingPlatform/GetDTDAssignmentDetailMultiplePort

export const GetDTDAssignmentDetailMultiplePort = [];
